import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import apiInstance from "../../apiInstance";

const Payments = () => {
    const user = useSelector((state) => state.currentUser);
    const [payments, setPayments] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchUserPayments = async () => {
            apiInstance
                .get(`/dashboard/payment`, {
                    params: {
                        userId: user.id,
                    },
                })
                .then((response) => {
                    const fetchedPayments = response.data.payments || [];
                    setPayments(fetchedPayments);
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load payments.");
                });
        };

        fetchUserPayments();
    }, [user.id]);

    return (
        <div className="mjs-dash-section">
            <div className="mjs-dash-sec-header">
                <h4>Payment History</h4>
            </div>
            <div className="mjs-dash-inner-container">
                <table className="mjs-table">
                    <thead>
                        <tr>
                            <th>Site Name</th>
                            <th>Amount($)</th>
                            <th>Payment Method</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th></th>
                        </tr>
                    </thead>

                    {payments.length > 0 ? (
                        <tbody>
                            {payments.map((payment) => (
                                <tr key={payment.id}>                                    
                                    <td>{payment.siteName || "-"}</td>
                                    <td>{payment.amount || "--"}</td>
                                    <td>{payment.methodDetail || "-"}</td>
                                    <td>{payment.status === 'paid' ? 'paid' : "failed"}</td>
                                    <td>
                                        {payment.created
                                            ? new Date(
                                                  payment.created * 1000
                                              ).toDateString()
                                            : "—"}
                                    </td>  
                                    {payment.status === 'open' &&
                                        <td className="mjs-table-actions">
                                            <button
                                                className='mjs-btn'
                                                onClick={() => {
                                                    if (payment.hosted_url) {
                                                        window.open(payment.hosted_url, "_blank", "noopener,noreferrer");
                                                    }
                                                }}
                                            >Retry</button>
                                        </td>
                                    }                                   
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="mjs-msg">
                                    No Payments found.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            <div className="mjs-error">{error}</div>
        </div>
    );
};

export default Payments;
